import { render, staticRenderFns } from "./SubmissionRules.vue?vue&type=template&id=e3cfc4e4&scoped=true&"
import script from "./SubmissionRules.vue?vue&type=script&lang=ts&"
export * from "./SubmissionRules.vue?vue&type=script&lang=ts&"
import style0 from "./SubmissionRules.vue?vue&type=style&index=0&id=e3cfc4e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3cfc4e4",
  null
  
)

export default component.exports